import { IUnprocessableEntity } from '../../Shared/HttpRequestExecutor';

export function isUnprocessableInvalidGroups(entity: unknown): entity is IUnprocessableInvalidGroups {
    return (entity as IUnprocessableInvalidGroups).content !== undefined;
}

export interface IInvalidGroup {
    id: string;
    name: string;
    authoringSystem: string;
    authoringSystemForeignKey: string;
}

export interface IUnprocessableInvalidGroups extends IUnprocessableEntity {
    content: IInvalidGroup[];
}

export enum AuthState {
    Allowed = 'allowed',
    Denied = 'denied'
}

export interface UserIUser {
    id: string;
    familyName: string;
    givenNames: string;
    username: string;
    email: string;
    enabled: boolean;
    isSystemContact: boolean;
    authoringSystem: string;
    authoringSystemForeignKey: string;
    groups: UserIParentGroup[];
}

export interface UserIParentGroup {
    id: string;
    name: string;
    authoringSystem: string;
    authoringSystemForeignKey: string;
}
